(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tm-livraison"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tm-delivery')) {
    class TmDelivery extends HTMLElement {
      connectedCallback() {
        const tz = this.dataset.timezone || 'Europe/Paris';
        const holidays = new Set((this.dataset.holidays || '').split(',').map((d) => d.trim()).filter(Boolean));
        const num = (key, fallback) => {
          const n = parseInt(this.dataset[key], 10);
          return Number.isFinite(n) && n >= 0 ? n : fallback;
        };
        const prepMin = num('prepMin', 1);
        const prepMax = Math.max(num('prepMax', prepMin), prepMin);
        const transMin = num('transportMin', 2);
        const transMax = Math.max(num('transportMax', transMin), transMin);

        const parts = new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
        const get = (type) => Number(parts.find((p) => p.type === type).value);
        const today = new Date(Date.UTC(get('year'), get('month') - 1, get('day')));

        const iso = (d) => d.toISOString().slice(0, 10);
        const isOff = (d) => d.getUTCDay() === 0 || d.getUTCDay() === 6 || holidays.has(iso(d));
        const addBusinessDays = (start, n) => {
          const d = new Date(start);
          let left = n;
          while (left > 0) {
            d.setUTCDate(d.getUTCDate() + 1);
            if (!isOff(d)) left -= 1;
          }
          while (isOff(d)) d.setUTCDate(d.getUTCDate() + 1);
          return d;
        };

        const dayMonth = new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', day: 'numeric', month: 'short' });
        const dayOnly = new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', day: 'numeric' });
        const monthOf = (d) => d.getUTCMonth();
        const format = (a, b) => {
          if (iso(a) === iso(b)) return dayMonth.format(a);
          if (monthOf(a) === monthOf(b)) return `${dayOnly.format(a)} au ${dayMonth.format(b)}`;
          return `${dayMonth.format(a)} au ${dayMonth.format(b)}`;
        };

        const set = (step, text) => {
          const el = this.querySelector(`[data-step="${step}"]`);
          if (el) el.textContent = text;
        };
        set('order', dayMonth.format(today));
        set('ship', format(addBusinessDays(today, prepMin), addBusinessDays(today, prepMax)));
        set('delivery', format(addBusinessDays(today, prepMin + transMin), addBusinessDays(today, prepMax + transMax)));
      }
    }
    customElements.define('tm-delivery', TmDelivery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tm-lot-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tm-lot-builder')) {
    class TmLotBuilder extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const island = this.querySelector('script[data-tm-lot-data]');
        this.data = JSON.parse(island.textContent);
        this.mode = 0;
        this.selection = [];
        this.slotIndex = 0;
        this.build();
        this.render();
      }

      esc(value) {
        const el = document.createElement('div');
        el.textContent = value == null ? '' : String(value);
        return el.innerHTML;
      }

      build() {
        const t = this.data.text;
        const wrap = document.createElement('div');
        wrap.innerHTML = `
          <div class="tm-lot__group">
            <p class="tm-lot__title">${this.esc(t.headingSets)}</p>
            <div class="tm-lot__cards" role="radiogroup" aria-label="${this.esc(t.headingSets)}"></div>
          </div>
          <div class="tm-lot__group">
            <p class="tm-lot__title">${this.esc(t.headingPieces)}</p>
            <div class="tm-lot__slots"></div>
          </div>
          <p class="tm-lot__error" role="alert" hidden></p>
          <button type="button" class="button tm-lot__cta" disabled></button>
          <dialog class="tm-lot__dialog" aria-label="${this.esc(t.dialogTitle)}">
            <div class="tm-lot__dialog-head">
              <h3 class="tm-lot__dialog-title">${this.esc(t.dialogTitle)}</h3>
              <button type="button" class="tm-lot__close" aria-label="Fermer">&times;</button>
            </div>
            <div class="tm-lot__dialog-body"></div>
          </dialog>`;
        while (wrap.firstChild) this.appendChild(wrap.firstChild);
        this.cards = this.querySelector('.tm-lot__cards');
        this.slots = this.querySelector('.tm-lot__slots');
        this.error = this.querySelector('.tm-lot__error');
        this.cta = this.querySelector('.tm-lot__cta');
        this.dialog = this.querySelector('.tm-lot__dialog');
        this.dialogBody = this.querySelector('.tm-lot__dialog-body');

        this.cards.addEventListener('click', (event) => {
          const card = event.target.closest('[data-mode]');
          if (!card) return;
          this.mode = Number(card.dataset.mode);
          this.render();
        });
        this.slots.addEventListener('click', (event) => {
          const slot = event.target.closest('[data-slot]');
          if (slot) this.openDialog(Number(slot.dataset.slot));
        });
        this.dialogBody.addEventListener('click', (event) => {
          const choice = event.target.closest('[data-variant]');
          if (!choice || choice.disabled) return;
          const variant = this.data.variants.find((v) => String(v.id) === choice.dataset.variant);
          this.selection[this.slotIndex] = variant;
          this.dialog.close();
          this.render();
        });
        this.querySelector('.tm-lot__close').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.cta.addEventListener('click', () => this.addToCart());
      }

      get option() {
        return this.data.options[this.mode];
      }

      isComplete() {
        for (let i = 0; i < this.option.count; i++) if (!this.selection[i]) return false;
        return true;
      }

      render() {
        const t = this.data.text;
        const option = this.option;

        this.cards.innerHTML = this.data.options
          .map((o, i) => {
            const price = i === 0 && this.selection[0] && this.mode === 0 ? this.selection[0].priceText : o.priceText;
            return `<button type="button" class="tm-lot__card" role="radio" data-mode="${i}" aria-checked="${i === this.mode}">
              <span class="tm-lot__badge">${this.esc(o.badge)}</span>
              <span class="tm-lot__card-body">
                <span class="tm-lot__card-label">${this.esc(o.label)}</span>
                <span class="tm-lot__card-price">${this.esc(price)}</span>
              </span>
            </button>`;
          })
          .join('');

        this.slots.dataset.count = option.count;
        let slotsHtml = '';
        for (let i = 0; i < option.count; i++) {
          const v = this.selection[i];
          slotsHtml += v
            ? `<button type="button" class="tm-lot__slot" data-slot="${i}" data-filled="true">
                ${v.image ? `<img class="tm-lot__thumb" src="${this.esc(v.image)}" alt="" loading="lazy">` : ''}
                <span class="tm-lot__slot-name">${this.esc(v.color)}</span>
                <span class="tm-lot__slot-sub">${this.esc(v.size)}</span>
              </button>`
            : `<button type="button" class="tm-lot__slot" data-slot="${i}" data-filled="false">
                <span class="tm-lot__plus" aria-hidden="true">+</span>
                <span class="tm-lot__slot-name">${this.esc(t.slotEmpty)}</span>
              </button>`;
        }
        this.slots.innerHTML = slotsHtml;

        const complete = this.isComplete();
        const lotBlocked = option.count > 1 && (!option.lotVariantId || option.lotAvailable === false);
        let price = option.priceText;
        if (option.count === 1 && this.selection[0]) price = this.selection[0].priceText;
        this.cta.disabled = !complete || lotBlocked;
        this.cta.textContent = complete ? `${t.ctaLabel} · ${price}` : t.ctaEmpty;
        this.error.hidden = true;
      }

      openDialog(index) {
        this.slotIndex = index;
        const current = this.selection[index];
        const t = this.data.text;
        const groups = [];
        this.data.variants.forEach((v) => {
          let group = groups.find((g) => g.size === v.size);
          if (!group) {
            group = { size: v.size, items: [] };
            groups.push(group);
          }
          group.items.push(v);
        });
        this.dialogBody.innerHTML = groups
          .map(
            (g) => `<p class="tm-lot__size">${this.esc(g.size)}</p>
              <div class="tm-lot__grid">
                ${g.items
                  .map(
                    (v) => `<button type="button" class="tm-lot__choice" data-variant="${v.id}" aria-pressed="${!!current && current.id === v.id}" ${v.available ? '' : 'disabled'}>
                      ${v.image ? `<img src="${this.esc(v.image)}" alt="" loading="lazy">` : ''}
                      <span class="tm-lot__choice-name">${this.esc(v.color)}</span>
                      <span class="tm-lot__choice-price">${v.available ? this.esc(v.priceText) : this.esc(t.soldOut)}</span>
                    </button>`
                  )
                  .join('')}
              </div>`
          )
          .join('');
        this.dialog.showModal();
      }

      async addToCart() {
        if (!this.isComplete()) return;
        const option = this.option;
        const picks = this.selection.slice(0, option.count);
        let item;
        if (option.count === 1) {
          item = { id: picks[0].id, quantity: 1 };
        } else {
          const properties = {};
          picks.forEach((v, i) => {
            properties[`Pince ${i + 1}`] = `${v.size} · ${v.color}`;
          });
          properties['_composition'] = picks.map((v) => v.id).join(',');
          item = { id: option.lotVariantId, quantity: 1, properties };
        }
        this.cta.disabled = true;
        try {
          const response = await fetch(this.data.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [item] }),
          });
          if (!response.ok) throw new Error('add failed');
          window.location.href = this.data.cartUrl;
        } catch (e) {
          this.error.textContent = this.data.text.error;
          this.error.hidden = false;
          this.cta.disabled = false;
        }
      }
    }
    customElements.define('tm-lot-builder', TmLotBuilder);
  }
  } catch(e) { console.error(e); }
})();

})();
